import { useTranslation } from "../../../../../localization/useTranslation";
import { Trans } from "react-i18next";
import AssociatedInternalAssessmentDialog from "../../../../../common/components/questionnaireComponents/associatedInternalAssessmentDialog/AssociatedInternalAssessmentDialog";
import useProcessingActivityInternalAssessmentDialogHooks from "./ProcessingActivityInternalAssessmentDialog.hooks";
import HighlightedName from "@common/components/HighlightedName";

export interface IProcessingActivityInternalAssessmentDialogProps {
    onDialogClose: () => void;
    processingActivityName: string;
    processingActivityId: string;
    existingInternalAssessments: Array<string>;
}

function ProcessingActivityInternalAssessmentDialog(props: IProcessingActivityInternalAssessmentDialogProps) {
    const { translateString } = useTranslation();
    const { addAssociatedInternalAssessment, removeAssociatedInternalAssessment, selectedInternalAssessments } =
        useProcessingActivityInternalAssessmentDialogHooks(props);
    return (
        <AssociatedInternalAssessmentDialog
            onDialogClose={props.onDialogClose}
            name={props.processingActivityName}
            dialogHeader={translateString("associateAssessmentToProcessingActivity")}
            dialogInfo={
                <Trans
                    i18nKey="associateAssessmentsToProcessingActivity"
                    values={{ name: props.processingActivityName }}
                    components={{
                        wrapper: <HighlightedName />,
                    }}
                />
            }
            chosenOptions={selectedInternalAssessments}
            onAddInternalAssessment={addAssociatedInternalAssessment}
            onDeleteInternalAssessment={removeAssociatedInternalAssessment}
            existingInternalAssessments={props.existingInternalAssessments}
        />
    );
}

export default ProcessingActivityInternalAssessmentDialog;
